import I18n from 'I18n';
import { getHumanizedDuration } from '../../utils/utils';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenuIcon } from '../../features/cardMenu';
import ToolRecommendationOptionalStep from '../../features/toolRecommendations/components/ToolRecommendationOptionalStep';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../constants/Navigation';
import ACLessonNavigator from 'academy-common-lib/components/navigation/contentNavigator/ACLessonNavigator';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAssetTitle = asset => {
  if (asset.type === 'QUIZ') {
    return I18n.text('learningCenter.lessonNavigator.quiz');
  }
  if (asset.type === 'PRACTICAL_EXERCISE_FLOW') {
    return I18n.text('learningCenter.practicalExercise.practicalExercise');
  }
  return asset.name;
};
const getAssetHelpText = asset => {
  if (asset.type === 'QUIZ') {
    return I18n.text('learningCenter.quiz.numQuestions', {
      count: asset.totalQuestions
    });
  }
  if (asset.type === 'PRACTICAL_EXERCISE_FLOW') {
    return asset.name;
  }
  if (asset.type === 'LINK') {
    return I18n.text(`learningCenter.resources.type.${asset.linkType || 'WEBSITE'}`);
  }
  return getHumanizedDuration(asset.duration);
};
const getLessonVideoCount = assets => {
  return assets.filter(asset => asset.type === 'VIDEO').length;
};
const getLessonChapterCount = assets => {
  return assets.filter(asset => asset.type === 'CHAPTER').length;
};
const LessonNavigator = ({
  id,
  trackId,
  name,
  duration,
  useCases,
  assets,
  active,
  activeAssetId,
  language
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(ACLessonNavigator, {
    active: active,
    activeAssetId: activeAssetId,
    assets: assets.map(asset => ({
      id: asset.id,
      title: getAssetTitle(asset),
      helpText: getAssetHelpText(asset),
      type: asset.type,
      complete: asset.completed,
      lessonId: id
    })),
    courseId: trackId,
    helpText: /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      children: [getLessonVideoCount(assets) > 0 && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.video",
            options: {
              count: getLessonVideoCount(assets)
            }
          })
        })
      }), getLessonChapterCount(assets) > 0 && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.chapter",
            options: {
              count: getLessonChapterCount(assets)
            }
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.lessonNavigator.info",
            options: {
              totalDuration: getHumanizedDuration(duration)
            }
          })
        })
      })]
    }),
    lessonId: id,
    menuIcon: /*#__PURE__*/_jsx(CardMenuIcon, {
      item: {
        id,
        type: 'LESSON',
        language
      },
      size: "medium",
      use: "transparent"
    }),
    optionalSteps: !isMobile && /*#__PURE__*/_jsx(ToolRecommendationOptionalStep, {
      to: trackId ? `/tracks/${trackId}/${id}/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}` : `/lessons/${id}/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}`,
      useCases: useCases
    }),
    title: name
  });
};
export default LessonNavigator;